import React from "react";
import { Box, Typography, Link, useTheme } from "@mui/material";
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const theme = useTheme();
  const { t } = useLanguage();

  return (
    <Box
      component="footer"
      sx={{
        borderTop: `1px solid ${theme.palette.primary.main}`,
        padding: theme.spacing(2),
        fontFamily: theme.typography.fontFamily,
        // ...existing styles/structure if any...
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box className="footer-info" sx={{ textAlign: "center", mb: 2 }}>
          <Typography variant="h5">ivasi </Typography>
          <Typography variant="body1">{t('footer.contact')} +49 176 622 86091</Typography>
          <Typography variant="body1">{t('footer.address')} Gröbenzeller Str. 22, 82178 Puchheim, Germany</Typography>
          <Typography variant="body1">{t('footer.email')} info@ivasi.biz</Typography>
        </Box>
        <Box className="footer-links" sx={{ display: "flex", gap: 2 }}>
          <Link href="https://www.linkedin.com" target="_blank" rel="noreferrer" underline="hover" color="primary">
            LinkedIn
          </Link>
          <Link href="https://www.facebook.com" target="_blank" rel="noreferrer" underline="hover" color="primary">
            Facebook
          </Link>
          <Link href="https://wa.me/1234567890" target="_blank" rel="noreferrer" underline="hover" color="primary">
            WhatsApp
          </Link>
        </Box>
      </Box>
      {/* ...existing styles/structure if any... */}
    </Box>
  );
};

export default Footer;
